import type { BoxProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';

export const TextEllipsisWrapper = styled(Box)<{ lineClamp?: number | string; wordBreak?: BoxProps['wordBreak'] }>`
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.lineClamp || 1};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: ${props => props.wordBreak || 'break-word'};
  white-space: break-spaces;
`;

/**
 * Collapse consecutive whitespace/newlines into single spaces.
 * Useful for preview text in clamped containers where blank lines
 * waste valuable clamp lines.
 */
export const collapseWhitespace = (text: string): string => text.replace(/\s+/g, ' ').trim();
